import { FC, HTMLAttributes, ReactNode } from 'react';
import { CircularLoader } from '@components/common/CircularLoader';
import { TableCell } from '@components/common/Table/TableCell/TableCell';
import { TableRow } from '@components/common/Table/TableRow/TableRow';
const TWO_ROOT_CELLS = 2;

export interface ITableBodyProps extends HTMLAttributes<HTMLTableSectionElement> {
  children?: ReactNode;
  isLoading?: boolean;
  columnsNumber: number;
}

export const TableBody: FC<ITableBodyProps> = ({ isLoading, columnsNumber, children, className, ...props }) => (
  <tbody className={className} {...props}>
    {isLoading ? (
      <TableRow>
        <TableCell className={'py-0'} colSpan={columnsNumber + TWO_ROOT_CELLS}>
          <div className={'flex w-full justify-center p-5'}>
            <CircularLoader />
          </div>
        </TableCell>
      </TableRow>
    ) : (
      children
    )}
  </tbody>
);
